import InputField from '@modules/formFields/InputField'
import SelectAdminTypeField from '@modules/formFields/SelectAdminTypeField'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import SelectField from '@modules/formFields/SelectField'
import SelectProviderField from '@modules/formFields/SelectProviderField'
import { uploadImageComponent } from '@modules/formFields/uploadImageComponent'
import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Field, Form, formValueSelector, reduxForm, SubmissionError } from 'redux-form/dist/redux-form'
import Consultations from '@services/Consultations'
import { history } from '@services/History'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

class AdministratorForm extends Component {
  administratorClient = Consultations.administrators

  submit = (values) => {
    const isCompanyAdmin = values.type === 'company' || values.type === 'PaaS'
    const isProviderAdmin = values.type === 'provider' || values.type === 'PaaS'

    const requestBody = {
      timezone: dayjs.tz.guess(),
      name: values.name,
      email: values.email,
      password: values.password,
      phone: values.phone,
      avatar: values.avatar,
      type: values.type,
      access: values.access,
      company_id: isCompanyAdmin ? values.company.id : undefined,
      provider_id: isProviderAdmin && values.provider ? values.provider.id : undefined,
    }

    if (this.props.initialValues.id) {
      return this.administratorClient
        .update(this.props.initialValues.id, requestBody)
        .then(() => history.push(`/administrator/${this.props.initialValues.id}`))
        .catch((err) => {
          window.alert(JSON.stringify(err.response.data.errors, null, 2))
          throw new SubmissionError({ ...err.response.data.errors, _error: err.response.data.message })
        })
    }

    return this.administratorClient
      .store(requestBody)
      .then(() => history.push('/administrator'))
      .catch((err) => {
        window.alert(JSON.stringify(err.response.data.errors, null, 2))
        throw new SubmissionError({ ...err.response.data.errors, _error: err.response.data.message })
      })
  }

  render() {
    const { handleSubmit, submitting, selectedType, t } = this.props

    return (
      <Form className="md-form" onSubmit={handleSubmit(this.submit)}>
        <div className="double-box">
          <div>
            <Field name="name" component={InputField} placeholder={t('Nombre')} label={<Trans>Nombre</Trans>} />
            <Field name="email" component={InputField} placeholder={t('Email')} label={<Trans>Email</Trans>} />
            <Field name="phone" component={InputField} placeholder={t('Teléfono')} label={<Trans>Teléfono</Trans>} />
          </div>
          <div>
            <Field name={'avatar'} component={uploadImageComponent} label={<Trans>Avatar</Trans>} />
          </div>
        </div>
        <Field
          simpleValue
          name="access"
          component={SelectField}
          options={[
            { id: 'medical', name: t('Medico') },
            { id: 'support', name: t('Soporte') },
          ]}
          label={<Trans>Tipo de acceso</Trans>}
          placeholder={t('Tipo de acceso')}
        />
        <Field
          simpleValue
          name="type"
          component={SelectAdminTypeField}
          label={<Trans>Tipo Administrador</Trans>}
          placeholder={t('Tipo Administrador')}
        />

        {(selectedType === 'company' || selectedType === 'PaaS') && (
          <Field
            name="company"
            component={SelectCompanyField}
            placeholder={t('Compañía')}
            label={<Trans>Compañía</Trans>}
          />
        )}

        {(selectedType === 'provider' || selectedType === 'PaaS') && (
          <Field
            name="provider"
            component={SelectProviderField}
            placeholder={t('Proveedor')}
            label={<Trans>Proveedor</Trans>}
          />
        )}

        <button type="submit" className="btn btn-primary" disabled={submitting}>
          <Trans>Guardar</Trans>
        </button>
      </Form>
    )
  }
}

const validate = (values, props) => {
  const { t } = props
  const errors = {}

  if (!values.name) {
    errors.name = t('Campo requerido')
  }
  if (!values.phone) {
    errors.phone = t('Campo requerido')
  } else if (!/^[0-9]{3,14}$/i.test(values.phone)) {
    errors.phone = t('Formato incorrecto')
  }
  if (!values.email) {
    errors.email = t('Campo requerido')
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = t('Email invalido')
  }

  if (!values.avatar) {
    errors.avatar = t('Campo requerido')
  }

  if (!values.type) {
    errors.type = t('Campo requerido')
  }

  const isCompanyAdmin = values.type === 'company' || values.type === 'PaaS'
  const isProviderAdmin = values.type === 'provider' || values.type === 'PaaS'

  if (isCompanyAdmin && !values.company) {
    errors.company = t('Campo requerido')
  }

  if (isProviderAdmin && !values.provider) {
    errors.provider = t('Campo requerido')
  }

  return errors
}

const mapStateToProps = (state) => ({
  selectedType: formValueSelector('administrator')(state, 'type'),
})

export default compose(
  withTranslation(),
  reduxForm({ form: 'administrator', validate }),
  connect(mapStateToProps)
)(AdministratorForm)
